import React, { useEffect, useState } from "react";
import { Button, Typography, Box } from "@mui/material";
import { theme } from "../services/Theme";
import "../App.css";

const Feed = (props) => {
  const { id, imageKey, description } = props.feed;
  let post;

  const [hovered, setHovered] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [imageKey]);

  const handleClick = (e) => {
    props.openModal(e.target);
  };
  const hover = () => {
    setHovered(true);
  };
  const notHover = () => {
    setHovered(false);
  };

  post = (
    <Button
      onMouseEnter={hover}
      onMouseLeave={notHover}
      sx={{
        padding: 0,
        textTransform: "none",
        width: "100%",
        display: "block",
        position: "relative",
        overflow: "hidden",
        aspectRatio: "1 / 1",
        backgroundColor: "rgba(16,16,16,1)",
      }}
      onClick={(e) => handleClick(e)}
    >
      {loaded === false && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            background:
              "linear-gradient(120deg, rgba(30,30,30,1) 0%, rgba(52,52,52,1) 45%, rgba(30,30,30,1) 100%)",
            backgroundSize: "220% 100%",
            animation: "imageShimmer 1.4s ease-in-out infinite",
            zIndex: 1,
          }}
        />
      )}

      <img
        id={id}
        width="100%"
        height="100%"
        style={{
          opacity: loaded ? 1 : 0,
          transition: "opacity 0.45s ease-out",
          position: "absolute",
          inset: 0,
          objectFit: "cover",
          objectPosition: "center",
        }}
        src={imageKey}
        alt={description}
        onLoad={() => setLoaded(true)}
        loading="lazy"
        decoding="async"
      />

      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          backgroundColor: "rgba(0,0,0,0.8)",
          width: "100%",
          opacity: hovered ? 100 : 0,
          transition: "ease-in-out 0.2s",
          pointerEvents: "none",
          zIndex: 2,
        }}
      >
        <Typography color={theme.palette.text.light}>{description}</Typography>
      </Box>

      <style>
        {`@keyframes imageShimmer {
            0% { background-position: 100% 0; }
            100% { background-position: -100% 0; }
          }`}
      </style>
    </Button>
  );

  return <React.Fragment>{post}</React.Fragment>;
};

export default Feed;
